module.exports = __webpack_public_path__ + "img/medi-mass-header.9ce0452.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/medi-mass/medi-mass-header.jpg
// module id = 614
// module chunks = 5